// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../../assets/stylesheets/variables.css\"","borderGrey2":"#e2e2e2","customGrey":"#4b4b4b","imageContainer":"_1nh1yruhsRl7Mh3e1rX4EY","imageFlex":"YfoPnnsGDAL9Uxfe_AjXD","image":"_1EUHPXKLYlj9iCUdXDNsW1","markerContainer":"AdxiZPy8EnGozv9iwaCqz","marker":"_2qcFFVNsJ0WL6kGO40DqMM","current":"_2LnJXDxyrQa5DPCI24pECp"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/product-detail/image-carousel-mobile/ImageCarouselMobile.css
// module id = 1032
// module chunks = 1